export const DAY_RANGE = [
  { key: '1M', value: 30 },
  { key: '3M', value: 90 },
  { key: '6M', value: 180 },
  { key: '1Y', value: 360 },
  { key: 'MAX', value: 0 },
];

const AllStock = {
  DAY_RANGE,
};

export default AllStock;
